import React from "react";
import { HiArrowRight } from "react-icons/hi";
import { useContactForm } from '../context/ContactFormContext';
import backgroundImage from './assets/Home/bg.png';

const GetStarted = () => {
  const { openForm } = useContactForm();
  return (
    <section 
      className="relative overflow-hidden bg-surface py-24 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }}
    >
      {/* Light overlay for cohesive bright theme */}
      <div className="absolute inset-0 bg-white/80 z-0"></div>
      {/* Background Glow */}
      {/* <div className="absolute inset-0">
        <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-brand/20 blur-[140px]" />
        <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-purple-500/10 blur-[120px]" />
      </div> */}

      {/* Grid Pattern */}
      {/* <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" /> */}

      <div className="relative max-w-6xl mx-auto z-10">
          <div className="relative z-10 text-center bg-white/90 border border-black/8 rounded-3xl px-6 sm:px-10 md:px-16 py-16 shadow-xl">
          
          {/* Section Label */}
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-8 rounded-full bg-brand-light text-brand text-sm font-semibold uppercase tracking-wide">
            <HiArrowRight className="text-base" />
            Get Started
          </div>

          {/* Heading */}
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-ink leading-tight mb-6">
            Create High-Impact Ads
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand to-accent">
  Without the Headache
</span>

          </h2>

          {/* Description */}
          <p className="max-w-2xl mx-auto text-ink-muted text-base sm:text-lg md:text-xl leading-relaxed mb-10">
            Launch professional video ads in minutes. No complex tools. No wasted
            budget. Just results.
          </p>

          {/* CTA */}
          <div className="flex justify-center">
            <button 
              onClick={openForm}
              className="group relative inline-flex items-center justify-center rounded-xl bg-brand px-8 py-4 text-lg font-semibold text-white transition-all hover:scale-105 hover:bg-brand-hover shadow-md"
            >
              Contact Sales
              <span className="ml-2 transition-transform group-hover:translate-x-1">
                →
              </span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
